// TODO: This should be in PosSetting
export enum MenuDirection {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical'
}